<template>
  <div id="business-employee-list">
    <vs-table
      ref="table"
      :sst="true"
      :max-items="100"
      @sort="handleSort"
      @selected="handleSelected"
      :data="employeesData"
      :total="paginationPageSize"
      class="card-table"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer" v-if="employeesDataCount">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{ (currentPage * paginationPageSize - (paginationPageSize - 1)) | persian_digits }}
                {{ $t('forms.to') }}
                {{
                  employeesDataCount - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : employeesDataCount | persian_digits
                }}
                {{ $t('forms.from') }} {{ employeesDataCount | persian_digits }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="paginationSetPageSize(5)">
                <span>{{ 5 | persian_digits }}</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="paginationSetPageSize(10)">
                <span>{{ 10 | persian_digits }}</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="paginationSetPageSize(50)">
                <span>{{ 50 | persian_digits }}</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="paginationSetPageSize(100)">
                <span>{{ 100 | persian_digits }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW BTN -->
          <vs-button class="ml-4" @click="$router.push({ name: 'business-employee-add' })">
            {{ $t('forms.add') }}
          </vs-button>
        </div>

        <!-- PAGINATION -->
        <div>
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="username">{{ $t('users.username') }}</vs-th>
        <vs-th sort-key="details.firstName">{{ $t('users.first_name') }}</vs-th>
        <vs-th sort-key="details.lastName">{{ $t('users.last_name') }}</vs-th>
        <vs-th sort-key="id">{{ $t('employees.state.state') }}</vs-th>
        <vs-th sort-key="id">{{ $t('employees.status.status') }}</vs-th>
        <vs-th>{{ $t('forms.actions') }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody id="table-body" v-if="data.length">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <div class="flex items-center">
                <avatar :id="tr.user.avatar" class="flex-shrink-0 mr-2" size="30px" />
                {{ tr.user.username | persian_digits }}
              </div>
            </vs-td>
            <vs-td>{{ tr.user.details ? tr.user.details.firstName : '' }}</vs-td>
            <vs-td>{{ tr.user.details ? tr.user.details.lastName : '' }}</vs-td>
            <vs-td>
              <CellBadges :data="tr.state" local="employees.state." />
            </vs-td>
            <vs-td>
              <CellBadges :data="tr.status" local="employees.status." />
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <CellActions :employee="tr" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- PAGINATION -->
    <div>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
// Store Module
import moduleEmployee from '@/store/employee/moduleEmployee.js'

//Cells
import CellActions from './CellActions.vue'
import CellBadges from './CellBadges.vue'
import Avatar from '@/views/components/common/Avatar'
import moduleBusiness from '@/store/business/moduleBusiness'

export default {
  name: 'EmployeeList',
  components: {
    Avatar,
    CellActions,
    CellBadges
  },
  data() {
    return {
      // Filter Options
      searchString: '',
      query: {},
      //Sort
      sort: {},
      businessId: '',
      currentPage: 1
    }
  },
  watch: {
    currentPage(val) {
      this.$store.commit('employee/SET_EMPLOYEES_SKIP', (val - 1) * this.paginationPageSize)
      this.updateTable()
    }
  },
  computed: {
    employeesDataCount() {
      return this.$store.state.employee.employeesCount
    },
    employeesData() {
      return this.$store.state.employee.employees
    },
    paginationPageSize() {
      return this.$store.state.employee.limit
    },
    totalPages() {
      return this.$store.getters['employee/totalPages']
    }
  },
  methods: {
    handleSelected(employee) {
      this.$router.push({ name: 'business-employee-view', params: { id: employee.id } })
    },
    setQuery() {
      this.$store.commit('employee/SET_EMPLOYEES_QUERY', { ...this.query, businessId: this.businessId })
      this.currentPage = 1
      this.updateTable()
    },
    updateTable() {
      this.$vs.loading({
        scale: 0.6
      })
      this.$store.dispatch('employee/fetchEmployees').finally(() => this.$vs.loading.close())
      this.$store.dispatch('employee/countEmployees')
    },
    paginationSetPageSize(items) {
      this.$store.commit('employee/SET_EMPLOYEES_LIMIT', items)
      this.updateTable()
    },
    setColumnFilter(column, val) {
      const filter = []
      let i = null
      for (i in val) {
        filter.push(val[i].value ? val[i].value : val[i].label)
      }
      this.query[column] = { $in: filter }
      this.setQuery()
    },
    resetColFilters() {
      this.searchString = ''
      this.query = []
      this.setQuery()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    handleSort(col, active) {
      if (col === null) return
      if (active !== null) {
        this.sort[col] = active === 'asc' ? 1 : -1
        this.query['sort'] = this.sort
      } else {
        delete this.query['sort']
      }
      this.setQuery()
    }
  },
  created() {
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }

    this.$vs.loading()
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
    this.$store.commit('business/SET_BUSINESSES_QUERY', {
      userId: this.$store.state.AppActiveUser.id
    })
    this.$store
      .dispatch('business/fetchBusinesses')
      .then(res => {
        this.businessId = res.data.businesses[0].id
        this.setQuery()
        this.updateTable()
      })
      .finally(() => this.$vs.loading.close())
  }
}
</script>
